import React from "react";
import "./styles.css";

const ModalFinalResponseComponent = ({
  finalResponse,
  closeModalFinalResponse,
  boolConfirmAppointment,
  onClickBtnFinalModal,
}) => {
  const clickOutsideModal = (event) => {
    if (!event.target.closest(".modal-content")) {
      closeModalFinalResponse();
      window.location.href =
        "https://clinicaalejandria.es/trasplante-capilar-cita-confirmada/";
    }
  };

  const onClickErrorMessage = () => {
    onClickBtnFinalModal();
  };

  return (
    <div>
      <div className="modalContainerFinalResponse">
        <div className="modalContentFinalResponse">
          {boolConfirmAppointment === true ? (
            <div>
              <h2>Cita confirmada</h2>
              <p>{finalResponse.message}</p>
              <div className="modalButtonFinalResponse">
                <button
                  className="btnModalFinalResponse"
                  onClick={clickOutsideModal}
                >
                  Cerrar
                </button>
              </div>
            </div>
          ) : (
            <div>
              <h2>Upps!!</h2>
              <p>{finalResponse.error.message}</p>
              <div className="modalButtonFinalResponse">
                <button
                  className="btnModalFinalResponse"
                  onClick={onClickErrorMessage}
                >
                  Aceptar
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalFinalResponseComponent;
